import axios from "axios";
import { received } from "../DocumentationReducer";
import { baseURL } from "../thunks";

export const deleteDocumentSubscription =
  ({ id }) =>
  async (dispatch) => {
    try {
      const deleteReq = await axios({
        method: "delete",
        url: baseURL + "documentation/documents/" + id + "/subscription",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return deleteReq;
    } catch (error) {
      console.log(error);
      dispatch(received({ error: true }));
    }
  };
